<template>
  <div>
    <b-tr v-for="model in topologyItem" :key="model.PcnCatalogNumber">
      <b-form-checkbox class="ml-3" :style="'padding-left:' + paddingLeft + 'rem'" v-model="model.Download" @click="setParent(model.Download)">
        <h6>
          {{ model.PcnCatalogNumber }}
        </h6>
      </b-form-checkbox>
    </b-tr>
  </div>
</template>
<script lang="ts">
import { Component, Mixins, Prop } from 'vue-property-decorator'

@Component({
  components: {
  },
})

export default class extends Mixins() {
  @Prop()
  public topologyItem!: any

  @Prop()
  public paddingLeft!: number

  public checkParent() {
    this.topologyItem.Download = true
    this.$emit('checkParent')
  }

  public setParent(value: boolean) {
    if (value) {
      this.checkParent()
    }
  }
}
</script>
